import React, { Fragment } from "react";
import { Button, Row, Col, Alert, Table } from "react-bootstrap";
import { EmptyBlank } from "../common";

const HeaderForm = ({ week }) => {
  return <Alert>{week} 주차</Alert>;
};

const StudentsForm = ({ students, handelEdit }) => {
  const column_max = 4;

  let rowHeader = [];
  for (let i = 0; i < column_max; i++) {
    rowHeader.push(
      <Fragment key={i}>
        <th>학생</th>
        <th>등급</th>
        <th>진행</th>
        <th>메모</th>
        <th style={{ visibility: "hidden" }}> </th>
      </Fragment>
    );
  }

  let rowStudents = [];
  if (students) {
    let temp = [];
    for (let i = 0; i < students.length; i += column_max) {
      temp.push(students.slice(i, i + column_max));
    }

    rowStudents = temp.map((it, index) => {
      return (
        <Fragment key={index}>
          <tr>
            {it.map((st, sIndex) => {
              return (
                <Fragment key={sIndex}>
                  <td>{st.displayName}</td>
                  <td>{st.grade}</td>
                  <td>{st.progress}</td>
                  <td>{st.memo}</td>
                  <td>
                    <Button
                      size="sm"
                      onClick={handelEdit}
                      name={"student"}
                      value={st._id}
                    >
                      수정
                    </Button>
                  </td>
                </Fragment>
              );
            })}
          </tr>
        </Fragment>
      );
    });
  } else {
    return <Fragment></Fragment>;
  }

  return (
    <Fragment>
      <Table striped>
        <thead>
          <tr>{rowHeader}</tr>
        </thead>
        <tbody>
          {rowStudents ?? (
            <tr>
              <td>데이타가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Fragment>
  );
};

const TeamsForm = ({ teams, handelEdit }) => {
  return (
    <Fragment>
      <Alert variant="info" />
      <Table striped>
        <thead>
          <tr>
            <th>팀</th>
            <th>등급</th>
            <th>진행</th>
            <th>메모</th>
            <th style={{ visibility: "hidden" }}> </th>
          </tr>
        </thead>
        <tbody>
          {teams ? (
            teams.map((it, index) => {
              return (
                <tr key={index}>
                  <td>{it.name}</td>
                  <td>{it.grade}</td>
                  <td>{it.progress}</td>
                  <td>{it.memo}</td>
                  <td>
                    <Button
                      size="sm"
                      onClick={handelEdit}
                      name={"team"}
                      value={it.name}
                    >
                      수정
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td>데이타가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Fragment>
  );
};

export const AssessmentDetailForm = ({ assessment, handelEdit }) => {
  return (
    <Fragment>
      {assessment ? (
        <Fragment>
          <HeaderForm week={assessment.week} />
          <StudentsForm
            students={assessment.students}
            handelEdit={handelEdit}
          />
          <TeamsForm teams={assessment.teams} handelEdit={handelEdit} />
        </Fragment>
      ) : undefined}
      <EmptyBlank />
    </Fragment>
  );
};
